import styled from "styled-components";

export const HierarchyDivContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  overflow: inherit;
  text-overflow: clip;
  white-space: pre-wrap;
`;

export const StyledDiv = styled.div`
    display: flex;
`;

interface ITitle{
    bold?: boolean;
}

export const Title = styled.span<ITitle>`
    font-size: 0.725rem;
    width: calc(100% - 30px);
    max-width: fit-content;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    cursor: pointer;
    transition: 100ms ease;
    &:hover{
      font-weight: bold;
  }
    ${(props) => props.bold ? `font-weight: bold;
    text-decoration: underline;` : ""}
`;

